// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TicketChatsPage_page__mtJk1 {
  --surface: #ffffff;
  --surface-soft: #f6f8fb;
  --border: #d9e0ea;
  --text: #162033;
  --muted: #667085;
  --blue: #2563eb;
  --green: #16a34a;
  --yellow: #d97706;
  --red: #dc2626;
  --violet: #7c3aed;
  display: grid;
  gap: 12px;
  padding: 0 16px 16px;
  color: var(--text);
}

.TicketChatsPage_topBar__\\+bBL3 {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) 220px auto auto;
  gap: 10px;
  align-items: center;
}

.TicketChatsPage_searchWrap__MTzQQ {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  min-height: 40px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--muted);
}

.TicketChatsPage_sortSelect__dfbAR {
  width: 100%;
}

.TicketChatsPage_kpiStrip__Dyg\\+6 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(116px, 1fr));
  gap: 8px;
}

.TicketChatsPage_kpiCard__5Wj-2,
.TicketChatsPage_kpiCardActive__gCCuj {
  display: grid;
  gap: 4px;
  min-width: 0;
  min-height: 72px;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text);
  text-align: left;
  cursor: pointer;
}

.TicketChatsPage_kpiCardActive__gCCuj {
  border-color: var(--blue);
  box-shadow: inset 3px 0 0 var(--blue);
}

.TicketChatsPage_kpiCard__5Wj-2 span,
.TicketChatsPage_kpiCardActive__gCCuj span {
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 12px;
  line-height: 1.25;
  color: var(--muted);
}

.TicketChatsPage_kpiCard__5Wj-2 strong,
.TicketChatsPage_kpiCardActive__gCCuj strong {
  font-size: 22px;
  line-height: 1.1;
}

.TicketChatsPage_quickFilters__T9gR3 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.TicketChatsPage_quickFilter__hIqDY,
.TicketChatsPage_quickFilterActive__FCux- {
  min-height: 34px;
  padding: 0 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text);
  cursor: pointer;
}

.TicketChatsPage_quickFilterActive__FCux- {
  border-color: var(--blue);
  background: #eff6ff;
  color: #1d4ed8;
}

.TicketChatsPage_workspace__d9glp {
  display: grid;
  grid-template-columns: minmax(320px, 390px) minmax(420px, 1fr) minmax(360px, 480px);
  gap: 12px;
  align-items: stretch;
  min-height: calc(var(--vh, 1vh) * 100 - 220px);
}

.TicketChatsPage_queuePane__dVzaE,
.TicketChatsPage_ticketPane__A\\+MfL,
.TicketChatsPage_chatPane__8zHpy {
  min-width: 0;
  min-height: 0;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
}

.TicketChatsPage_queuePane__dVzaE,
.TicketChatsPage_chatPane__8zHpy {
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
}

.TicketChatsPage_ticketPane__A\\+MfL {
  overflow: auto;
  padding: 14px;
  -webkit-user-select: text;
          user-select: text;
}

.TicketChatsPage_paneHeader__532wK {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  min-height: 58px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
  background: var(--surface-soft);
}

.TicketChatsPage_paneHeader__532wK div {
  display: grid;
  gap: 2px;
  min-width: 0;
}

.TicketChatsPage_paneHeader__532wK span {
  font-size: 12px;
  color: var(--muted);
}

.TicketChatsPage_paneHeader__532wK strong {
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 18px;
}

.TicketChatsPage_queueList__oCxST {
  display: grid;
  align-content: start;
  gap: 8px;
  min-height: 0;
  max-height: calc(var(--vh, 1vh) * 100 - 300px);
  overflow: auto;
  padding: 10px;
}

.TicketChatsPage_queueCard__t0ANc,
.TicketChatsPage_queueCardActive__RwjFN {
  position: relative;
  display: grid;
  gap: 9px;
  width: 100%;
  min-width: 0;
  padding: 12px 12px 12px 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text);
  text-align: left;
  cursor: pointer;
}

.TicketChatsPage_queueCard__t0ANc::before,
.TicketChatsPage_queueCardActive__RwjFN::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px;
  bottom: 8px;
  width: 3px;
  border-radius: 0 4px 4px 0;
  background: var(--ticket-accent, #64748b);
}

.TicketChatsPage_queueCardActive__RwjFN {
  border-color: var(--blue);
  background: #f8fbff;
}

.TicketChatsPage_queueCardUrgent__XfQlN {
  border-color: #f9a8d4;
  background: #fff5fa;
}

.TicketChatsPage_queueTop__RVqka,
.TicketChatsPage_queueMeta__YeBDV {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  color: var(--muted);
  font-size: 12px;
}

.TicketChatsPage_queueTop__RVqka strong {
  color: var(--text);
}

.TicketChatsPage_queueMeta__YeBDV span {
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.TicketChatsPage_queueTitle__QObgp {
  min-width: 0;
  overflow-wrap: anywhere;
  font-weight: 700;
  line-height: 1.35;
}

.TicketChatsPage_badgeRow__IVCBC {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.TicketChatsPage_statusPill__lcERd,
.TicketChatsPage_smallPill__byCXo,
.TicketChatsPage_alertPill__Kk\\+Xx,
.TicketChatsPage_terminalPaymentPill__D\\+yWp,
.TicketChatsPage_taskTagPill__CRcHs {
  display: inline-flex;
  align-items: center;
  min-width: 0;
  min-height: 24px;
  max-width: 100%;
  padding: 3px 8px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.TicketChatsPage_statusPill__lcERd {
  background: color-mix(in srgb, var(--status-color, #64748b) 14%, white);
  color: var(--status-color, #64748b);
}

.TicketChatsPage_smallPill__byCXo {
  background: #eef2f7;
  color: #475467;
}

.TicketChatsPage_alertPill__Kk\\+Xx {
  background: #fee2e2;
  color: var(--red);
}

.TicketChatsPage_terminalPaymentPill__D\\+yWp {
  background: #fce7f3;
  color: #be185d;
}

.TicketChatsPage_taskTagPill__CRcHs {
  border: 1px solid rgba(15, 23, 42, 0.08);
  color: #162033;
}

.TicketChatsPage_waitingStaff__X6Jjs {
  background: #dbeafe;
  color: #1d4ed8;
}

.TicketChatsPage_waitingClient__mR\\+I0 {
  background: #fef3c7;
  color: #92400e;
}

.TicketChatsPage_lastMessage__wH7Cv {
  min-width: 0;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: var(--muted);
  font-size: 13px;
  line-height: 1.35;
}

.TicketChatsPage_ticketHeader__LyIRO {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 14px;
  align-items: start;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border);
}

.TicketChatsPage_ticketEyebrow__20hrB {
  color: var(--muted);
  font-weight: 700;
  margin-bottom: 4px;
}

.TicketChatsPage_ticketHeader__LyIRO h1 {
  min-width: 0;
  margin: 0;
  overflow-wrap: anywhere;
  font-size: 24px;
  line-height: 1.2;
  letter-spacing: 0;
}

.TicketChatsPage_ticketTitleInline__QEh8D {
  font-size: inherit;
  font-weight: 800;
  line-height: inherit;
}

.TicketChatsPage_ticketTags__6qkua,
.TicketChatsPage_actionBar__orzIQ,
.TicketChatsPage_bottomActions__K7LR8 {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.TicketChatsPage_ticketTags__6qkua {
  margin-top: 10px;
  align-items: center;
}

.TicketChatsPage_ticketTagEditor__\\+P9US {
  flex: 1 1 220px;
}

.TicketChatsPage_actionBar__orzIQ {
  justify-content: flex-end;
}

.TicketChatsPage_slaRow__4ceZa {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.TicketChatsPage_slaBadge__Wkztr,
.TicketChatsPage_waitingBox__NqJv\\+ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-width: 0;
  min-height: 64px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid var(--border);
  background: var(--surface-soft);
}

.TicketChatsPage_slaBadge__Wkztr {
  display: grid;
}

.TicketChatsPage_slaBadge__Wkztr span,
.TicketChatsPage_waitingBox__NqJv\\+ span {
  color: var(--muted);
  font-size: 12px;
}

.TicketChatsPage_slaBadge__Wkztr strong,
.TicketChatsPage_waitingBox__NqJv\\+ strong {
  min-width: 0;
  overflow-wrap: anywhere;
}

.TicketChatsPage_sla_success__85m-\\+ {
  background: #ecfdf3;
  color: #027a48;
}

.TicketChatsPage_sla_warning__HhJPB {
  background: #fffaeb;
  color: #b54708;
}

.TicketChatsPage_sla_danger__tmEEq {
  background: #fef3f2;
  color: #b42318;
}

.TicketChatsPage_sla_pause__pxLDN {
  background: #f4f3ff;
  color: var(--violet);
}

.TicketChatsPage_sla_done__2GzCn {
  background: #eef2f7;
  color: #475467;
}

.TicketChatsPage_waitingBox__NqJv\\+ {
  justify-content: flex-start;
}

.TicketChatsPage_ratingPanel__xn-kB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-width: 0;
  margin-top: 14px;
  padding: 10px 12px;
  border: 1px solid #fde68a;
  border-radius: 8px;
  background: #fffbeb;
}

.TicketChatsPage_ratingText__ZRD9F {
  display: grid;
  gap: 3px;
  min-width: 0;
}

.TicketChatsPage_ratingText__ZRD9F span,
.TicketChatsPage_ratingNote__wKGyL {
  color: #92400e;
  font-size: 12px;
  line-height: 1.25;
}

.TicketChatsPage_ratingText__ZRD9F strong {
  color: #78350f;
  overflow-wrap: anywhere;
}

.TicketChatsPage_ratingButtons__k8hfk {
  display: grid;
  grid-template-columns: repeat(5, 36px);
  gap: 6px;
  flex: 0 0 auto;
}

.TicketChatsPage_ratingButton__38-bz {
  width: 36px;
  min-height: 34px;
  border: 1px solid #f59e0b;
  border-radius: 8px;
  background: #fff;
  color: #92400e;
  font-weight: 800;
  cursor: pointer;
}

.TicketChatsPage_ratingButton__38-bz:hover,
.TicketChatsPage_ratingButton__38-bz:focus-visible,
.TicketChatsPage_ratingButtonActive__4ytJ0 {
  background: #f59e0b;
  color: #fff;
  outline: none;
}

.TicketChatsPage_ratingButton__38-bz:disabled {
  cursor: not-allowed;
  opacity: 0.58;
}

.TicketChatsPage_fieldGrid__erY4s {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 10px;
  margin-top: 14px;
}

.TicketChatsPage_field__hkk\\+k {
  display: grid;
  gap: 4px;
  min-width: 0;
  padding: 10px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface-soft);
}

.TicketChatsPage_field__hkk\\+k span {
  color: var(--muted);
  font-size: 12px;
}

.TicketChatsPage_fieldValue__SLTmP,
.TicketChatsPage_field__hkk\\+k strong {
  min-width: 0;
  overflow-wrap: anywhere;
  font-size: 13px;
  line-height: 1.3;
}

.TicketChatsPage_fieldValue__SLTmP {
  font-weight: 700;
}

.TicketChatsPage_descriptionBlock__bBeug,
.TicketChatsPage_attachmentsBlock__PpEAJ,
.TicketChatsPage_historyBlock__w\\+QeH {
  display: grid;
  gap: 8px;
  margin-top: 14px;
  padding: 12px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--surface);
}

.TicketChatsPage_descriptionBlock__bBeug p,
.TicketChatsPage_attachmentsBlock__PpEAJ p,
.TicketChatsPage_historyBlock__w\\+QeH p {
  margin: 0;
  color: var(--text);
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.TicketChatsPage_sectionTitle__jOK0G {
  font-weight: 800;
}

.TicketChatsPage_attachmentsList__H\\+NZM {
  display: grid;
  gap: 6px;
}

.TicketChatsPage_attachmentsList__H\\+NZM a {
  min-width: 0;
  overflow-wrap: anywhere;
}

.TicketChatsPage_historyList__8MLAY {
  display: grid;
  gap: 8px;
}

.TicketChatsPage_historyItem__5J\\+C\\+ {
  display: grid;
  grid-template-columns: minmax(100px, 0.8fr) minmax(140px, 1fr) auto;
  gap: 8px;
  align-items: center;
  min-width: 0;
  font-size: 13px;
}

.TicketChatsPage_historyItem__5J\\+C\\+ strong,
.TicketChatsPage_historyItem__5J\\+C\\+ span,
.TicketChatsPage_historyItem__5J\\+C\\+ em {
  min-width: 0;
  overflow-wrap: anywhere;
}

.TicketChatsPage_historyItem__5J\\+C\\+ em {
  color: var(--muted);
  font-style: normal;
}

.TicketChatsPage_bottomActions__K7LR8 {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--border);
}

.TicketChatsPage_chatPane__8zHpy .chatContainer {
  min-height: 0;
  height: 100%;
  padding: 10px;
  border-radius: 0;
  background: var(--surface);
}
.TicketChatsPage_chatPane__8zHpy .chatMessages {
  min-height: 340px;
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: none;
}
.TicketChatsPage_chatPane__8zHpy .chatInput {
  position: sticky;
  bottom: 0;
  padding-top: 8px;
  background: var(--surface);
}
.TicketChatsPage_chatPane__8zHpy .message,
.TicketChatsPage_chatPane__8zHpy .previewAttachment,
.TicketChatsPage_chatPane__8zHpy .fileAttachment,
.TicketChatsPage_chatPane__8zHpy .messageInput,
.TicketChatsPage_chatPane__8zHpy .editMessageInput,
.TicketChatsPage_chatPane__8zHpy .fileInputLabel,
.TicketChatsPage_chatPane__8zHpy .templateButton,
.TicketChatsPage_chatPane__8zHpy .sendButton,
.TicketChatsPage_chatPane__8zHpy .saveEditButton,
.TicketChatsPage_chatPane__8zHpy .cancelEditButton,
.TicketChatsPage_chatPane__8zHpy .toggleControl {
  border-radius: 8px;
}

.TicketChatsPage_drawerStack__aqcYj,
.TicketChatsPage_modalStack__MObg0 {
  display: grid;
  gap: 12px;
}

.TicketChatsPage_drawerStack__aqcYj label {
  display: grid;
  gap: 6px;
  color: var(--muted);
  font-size: 13px;
  font-weight: 700;
}

.TicketChatsPage_drawerStack__aqcYj .ant-select,
.TicketChatsPage_drawerStack__aqcYj .ant-input {
  width: 100%;
}

.TicketChatsPage_checkboxRow__gpYok {
  display: flex !important;
  grid-template-columns: none !important;
  align-items: center;
  gap: 8px !important;
  color: var(--text) !important;
}

.TicketChatsPage_checkboxRow__gpYok input {
  width: 16px;
  height: 16px;
}

.TicketChatsPage_modalControl__wj\\+kb {
  width: 100%;
}

@media (max-width: 1680px) {
  .TicketChatsPage_kpiStrip__Dyg\\+6 {
    grid-template-columns: repeat(5, minmax(140px, 1fr));
  }
  .TicketChatsPage_workspace__d9glp {
    grid-template-columns: minmax(300px, 360px) minmax(420px, 1fr) minmax(340px, 430px);
  }
}
@media (max-width: 1320px) {
  .TicketChatsPage_workspace__d9glp {
    grid-template-columns: minmax(300px, 360px) minmax(0, 1fr);
  }
  .TicketChatsPage_chatPane__8zHpy {
    grid-column: 1/-1;
    min-height: 520px;
  }
  .TicketChatsPage_fieldGrid__erY4s {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 980px) {
  .TicketChatsPage_topBar__\\+bBL3 {
    grid-template-columns: 1fr;
  }
  .TicketChatsPage_kpiStrip__Dyg\\+6 {
    grid-template-columns: repeat(2, minmax(140px, 1fr));
  }
  .TicketChatsPage_workspace__d9glp {
    grid-template-columns: 1fr;
    min-height: auto;
  }
  .TicketChatsPage_queueList__oCxST {
    max-height: 460px;
  }
  .TicketChatsPage_ticketHeader__LyIRO {
    grid-template-columns: 1fr;
  }
  .TicketChatsPage_actionBar__orzIQ {
    justify-content: flex-start;
  }
  .TicketChatsPage_slaRow__4ceZa,
  .TicketChatsPage_fieldGrid__erY4s {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 640px) {
  .TicketChatsPage_page__mtJk1 {
    padding: 0 8px 12px;
  }
  .TicketChatsPage_kpiStrip__Dyg\\+6,
  .TicketChatsPage_slaRow__4ceZa,
  .TicketChatsPage_fieldGrid__erY4s {
    grid-template-columns: 1fr;
  }
  .TicketChatsPage_queueTop__RVqka,
  .TicketChatsPage_queueMeta__YeBDV,
  .TicketChatsPage_historyItem__5J\\+C\\+ {
    grid-template-columns: 1fr;
    flex-direction: column;
  }
  .TicketChatsPage_queueMeta__YeBDV {
    align-items: flex-start;
  }
  .TicketChatsPage_ticketHeader__LyIRO h1 {
    font-size: 20px;
  }
  .TicketChatsPage_ratingPanel__xn-kB {
    display: grid;
    align-items: stretch;
  }
  .TicketChatsPage_ratingButtons__k8hfk {
    grid-template-columns: repeat(5, minmax(34px, 1fr));
  }
  .TicketChatsPage_bottomActions__K7LR8 .ant-btn,
  .TicketChatsPage_actionBar__orzIQ .ant-btn {
    flex: 1 1 140px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/TicketChatsPage/TicketChatsPage.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EAEA,aAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,yDAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,aAAA;EACA,2DAAA;EACA,QAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;EACA,qCAAA;AAAF;;AAGA;;EAEE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAAF;;AAGA;;EAEE,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAAF;;AAGA;;EAEE,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AAAF;;AAGA;EACE,yBAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mFAAA;EACA,SAAA;EACA,oBAAA;EACA,8CAAA;AAAF;;AAGA;;;EAGE,YAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,0BAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,4CAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cAAA;EACA,aAAA;EACA,yBAAA;UAAA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,sCAAA;EACA,+BAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAAF;;AAGA;EACE,eAAA;EACA,mBAAA;AAAF;;AAGA;EACE,YAAA;EACA,uBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,oBAAA;EACA,QAAA;EACA,aAAA;EACA,8CAAA;EACA,cAAA;EACA,aAAA;AAAF;;AAGA;;EAEE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,+BAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;;EAEE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,0BAAA;EACA,yCAAA;AAAF;;AAGA;EACE,yBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,qBAAA;EACA,mBAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAAF;;AAGA;;;;;EAKE,oBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,uEAAA;EACA,mCAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,wCAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,YAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;EACA,oBAAA;EACA,sCAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,YAAA;EACA,SAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,oBAAA;AAAF;;AAGA;;;EAGE,aAAA;EACA,eAAA;EACA,QAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,+BAAA;EACA,+BAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;;EAEE,mBAAA;EACA,eAAA;AAAF;;AAGA;;EAEE,YAAA;EACA,uBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,mBAAA;EACA,oBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,YAAA;AAAF;;AAGA;;EAEE,cAAA;EACA,eAAA;EACA,iBAAA;AAAF;;AAGA;EACE,cAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sCAAA;EACA,QAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAGA;;;EAGE,mBAAA;EACA,WAAA;EACA,aAAA;AAAF;;AAGA;EACE,mBAAA;EACA,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;AAAF;;AAGA;EACE,mBAAA;EACA,eAAA;AAAF;;AAGA;;EAEE,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;;;EAGE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,aAAA;EACA,+BAAA;EACA,kBAAA;EACA,0BAAA;AAAF;;AAGA;;;EAGE,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;AAAF;;AAGA;EACE,gBAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;AAAF;;AAGA;EACE,YAAA;EACA,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,QAAA;AAAF;;AAGA;EACE,aAAA;EACA,mEAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AAAF;;AAGA;;;EAGE,YAAA;EACA,uBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,kBAAA;AAAF;;AAGA;EACE,gBAAA;EACA,iBAAA;EACA,mCAAA;AAAF;;AAIE;EACE,aAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,0BAAA;AADJ;AAIE;EACE,iBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,0BAAA;AAHJ;AAME;;;;;;;;;;;EAWE,kBAAA;AAJJ;;AAQA;;EAEE,aAAA;EACA,SAAA;AALF;;AAQA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AALF;;AAQA;;EAEE,WAAA;AALF;;AAQA;EACE,wBAAA;EACA,sCAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AALF;;AAQA;EACE,WAAA;EACA,YAAA;AALF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE;IACE,oDAAA;EALF;EAQA;IACE,mFAAA;EANF;AACF;AASA;EACE;IACE,0DAAA;EAPF;EAUA;IACE,iBAAA;IACA,iBAAA;EARF;EAWA;IACE,gDAAA;EATF;AACF;AAYA;EACE;IACE,0BAAA;EAVF;EAaA;IACE,oDAAA;EAXF;EAcA;IACE,0BAAA;IACA,gBAAA;EAZF;EAeA;IACE,iBAAA;EAbF;EAgBA;IACE,0BAAA;EAdF;EAiBA;IACE,2BAAA;EAfF;EAkBA;;IAEE,8BAAA;EAhBF;AACF;AAmBA;EACE;IACE,mBAAA;EAjBF;EAoBA;;;IAGE,0BAAA;EAlBF;EAqBA;;;IAGE,0BAAA;IACA,sBAAA;EAnBF;EAsBA;IACE,uBAAA;EApBF;EAuBA;IACE,eAAA;EArBF;EAwBA;IACE,aAAA;IACA,oBAAA;EAtBF;EAyBA;IACE,mDAAA;EAvBF;EA0BA;;IAEE,eAAA;EAxBF;AACF","sourcesContent":[".page {\n  --surface: #ffffff;\n  --surface-soft: #f6f8fb;\n  --border: #d9e0ea;\n  --text: #162033;\n  --muted: #667085;\n  --blue: #2563eb;\n  --green: #16a34a;\n  --yellow: #d97706;\n  --red: #dc2626;\n  --violet: #7c3aed;\n\n  display: grid;\n  gap: 12px;\n  padding: 0 16px 16px;\n  color: var(--text);\n}\n\n.topBar {\n  display: grid;\n  grid-template-columns: minmax(280px, 1fr) 220px auto auto;\n  gap: 10px;\n  align-items: center;\n}\n\n.searchWrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  min-height: 40px;\n  padding: 0 12px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--muted);\n}\n\n.sortSelect {\n  width: 100%;\n}\n\n.kpiStrip {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(116px, 1fr));\n  gap: 8px;\n}\n\n.kpiCard,\n.kpiCardActive {\n  display: grid;\n  gap: 4px;\n  min-width: 0;\n  min-height: 72px;\n  padding: 10px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--text);\n  text-align: left;\n  cursor: pointer;\n}\n\n.kpiCardActive {\n  border-color: var(--blue);\n  box-shadow: inset 3px 0 0 var(--blue);\n}\n\n.kpiCard span,\n.kpiCardActive span {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  font-size: 12px;\n  line-height: 1.25;\n  color: var(--muted);\n}\n\n.kpiCard strong,\n.kpiCardActive strong {\n  font-size: 22px;\n  line-height: 1.1;\n}\n\n.quickFilters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.quickFilter,\n.quickFilterActive {\n  min-height: 34px;\n  padding: 0 12px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--text);\n  cursor: pointer;\n}\n\n.quickFilterActive {\n  border-color: var(--blue);\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n\n.workspace {\n  display: grid;\n  grid-template-columns: minmax(320px, 390px) minmax(420px, 1fr) minmax(360px, 480px);\n  gap: 12px;\n  align-items: stretch;\n  min-height: calc((var(--vh, 1vh) * 100) - 220px);\n}\n\n.queuePane,\n.ticketPane,\n.chatPane {\n  min-width: 0;\n  min-height: 0;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n}\n\n.queuePane,\n.chatPane {\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr) auto;\n  overflow: hidden;\n}\n\n.ticketPane {\n  overflow: auto;\n  padding: 14px;\n  user-select: text;\n}\n\n.paneHeader {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  align-items: center;\n  min-height: 58px;\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border);\n  background: var(--surface-soft);\n}\n\n.paneHeader div {\n  display: grid;\n  gap: 2px;\n  min-width: 0;\n}\n\n.paneHeader span {\n  font-size: 12px;\n  color: var(--muted);\n}\n\n.paneHeader strong {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  font-size: 18px;\n}\n\n.queueList {\n  display: grid;\n  align-content: start;\n  gap: 8px;\n  min-height: 0;\n  max-height: calc((var(--vh, 1vh) * 100) - 300px);\n  overflow: auto;\n  padding: 10px;\n}\n\n.queueCard,\n.queueCardActive {\n  position: relative;\n  display: grid;\n  gap: 9px;\n  width: 100%;\n  min-width: 0;\n  padding: 12px 12px 12px 14px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n  color: var(--text);\n  text-align: left;\n  cursor: pointer;\n}\n\n.queueCard::before,\n.queueCardActive::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 8px;\n  bottom: 8px;\n  width: 3px;\n  border-radius: 0 4px 4px 0;\n  background: var(--ticket-accent, #64748b);\n}\n\n.queueCardActive {\n  border-color: var(--blue);\n  background: #f8fbff;\n}\n\n.queueCardUrgent {\n  border-color: #f9a8d4;\n  background: #fff5fa;\n}\n\n.queueTop,\n.queueMeta {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  min-width: 0;\n  color: var(--muted);\n  font-size: 12px;\n}\n\n.queueTop strong {\n  color: var(--text);\n}\n\n.queueMeta span {\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.queueTitle {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  font-weight: 700;\n  line-height: 1.35;\n}\n\n.badgeRow {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.statusPill,\n.smallPill,\n.alertPill,\n.terminalPaymentPill,\n.taskTagPill {\n  display: inline-flex;\n  align-items: center;\n  min-width: 0;\n  min-height: 24px;\n  max-width: 100%;\n  padding: 3px 8px;\n  border-radius: 8px;\n  font-size: 12px;\n  line-height: 1.2;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.statusPill {\n  background: color-mix(in srgb, var(--status-color, #64748b) 14%, white);\n  color: var(--status-color, #64748b);\n}\n\n.smallPill {\n  background: #eef2f7;\n  color: #475467;\n}\n\n.alertPill {\n  background: #fee2e2;\n  color: var(--red);\n}\n\n.terminalPaymentPill {\n  background: #fce7f3;\n  color: #be185d;\n}\n\n.taskTagPill {\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  color: #162033;\n}\n\n.waitingStaff {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.waitingClient {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.lastMessage {\n  min-width: 0;\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  color: var(--muted);\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.ticketHeader {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 14px;\n  align-items: start;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--border);\n}\n\n.ticketEyebrow {\n  color: var(--muted);\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.ticketHeader h1 {\n  min-width: 0;\n  margin: 0;\n  overflow-wrap: anywhere;\n  font-size: 24px;\n  line-height: 1.2;\n  letter-spacing: 0;\n}\n\n.ticketTitleInline {\n  font-size: inherit;\n  font-weight: 800;\n  line-height: inherit;\n}\n\n.ticketTags,\n.actionBar,\n.bottomActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.ticketTags {\n  margin-top: 10px;\n  align-items: center;\n}\n\n.ticketTagEditor {\n  flex: 1 1 220px;\n}\n\n.actionBar {\n  justify-content: flex-end;\n}\n\n.slaRow {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.slaBadge,\n.waitingBox {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  min-width: 0;\n  min-height: 64px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  background: var(--surface-soft);\n}\n\n.slaBadge {\n  display: grid;\n}\n\n.slaBadge span,\n.waitingBox span {\n  color: var(--muted);\n  font-size: 12px;\n}\n\n.slaBadge strong,\n.waitingBox strong {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.sla_success {\n  background: #ecfdf3;\n  color: #027a48;\n}\n\n.sla_warning {\n  background: #fffaeb;\n  color: #b54708;\n}\n\n.sla_danger {\n  background: #fef3f2;\n  color: #b42318;\n}\n\n.sla_pause {\n  background: #f4f3ff;\n  color: var(--violet);\n}\n\n.sla_done {\n  background: #eef2f7;\n  color: #475467;\n}\n\n.waitingBox {\n  justify-content: flex-start;\n}\n\n.ratingPanel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  min-width: 0;\n  margin-top: 14px;\n  padding: 10px 12px;\n  border: 1px solid #fde68a;\n  border-radius: 8px;\n  background: #fffbeb;\n}\n\n.ratingText {\n  display: grid;\n  gap: 3px;\n  min-width: 0;\n}\n\n.ratingText span,\n.ratingNote {\n  color: #92400e;\n  font-size: 12px;\n  line-height: 1.25;\n}\n\n.ratingText strong {\n  color: #78350f;\n  overflow-wrap: anywhere;\n}\n\n.ratingButtons {\n  display: grid;\n  grid-template-columns: repeat(5, 36px);\n  gap: 6px;\n  flex: 0 0 auto;\n}\n\n.ratingButton {\n  width: 36px;\n  min-height: 34px;\n  border: 1px solid #f59e0b;\n  border-radius: 8px;\n  background: #fff;\n  color: #92400e;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.ratingButton:hover,\n.ratingButton:focus-visible,\n.ratingButtonActive {\n  background: #f59e0b;\n  color: #fff;\n  outline: none;\n}\n\n.ratingButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.58;\n}\n\n.fieldGrid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.field {\n  display: grid;\n  gap: 4px;\n  min-width: 0;\n  padding: 10px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface-soft);\n}\n\n.field span {\n  color: var(--muted);\n  font-size: 12px;\n}\n\n.fieldValue,\n.field strong {\n  min-width: 0;\n  overflow-wrap: anywhere;\n  font-size: 13px;\n  line-height: 1.3;\n}\n\n.fieldValue {\n  font-weight: 700;\n}\n\n.descriptionBlock,\n.attachmentsBlock,\n.historyBlock {\n  display: grid;\n  gap: 8px;\n  margin-top: 14px;\n  padding: 12px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--surface);\n}\n\n.descriptionBlock p,\n.attachmentsBlock p,\n.historyBlock p {\n  margin: 0;\n  color: var(--text);\n  line-height: 1.5;\n  overflow-wrap: anywhere;\n}\n\n.sectionTitle {\n  font-weight: 800;\n}\n\n.attachmentsList {\n  display: grid;\n  gap: 6px;\n}\n\n.attachmentsList a {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.historyList {\n  display: grid;\n  gap: 8px;\n}\n\n.historyItem {\n  display: grid;\n  grid-template-columns: minmax(100px, 0.8fr) minmax(140px, 1fr) auto;\n  gap: 8px;\n  align-items: center;\n  min-width: 0;\n  font-size: 13px;\n}\n\n.historyItem strong,\n.historyItem span,\n.historyItem em {\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n\n.historyItem em {\n  color: var(--muted);\n  font-style: normal;\n}\n\n.bottomActions {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border);\n}\n\n.chatPane {\n  :global(.chatContainer) {\n    min-height: 0;\n    height: 100%;\n    padding: 10px;\n    border-radius: 0;\n    background: var(--surface);\n  }\n\n  :global(.chatMessages) {\n    min-height: 340px;\n    border: 1px solid var(--border);\n    border-radius: 8px;\n    box-shadow: none;\n  }\n\n  :global(.chatInput) {\n    position: sticky;\n    bottom: 0;\n    padding-top: 8px;\n    background: var(--surface);\n  }\n\n  :global(.message),\n  :global(.previewAttachment),\n  :global(.fileAttachment),\n  :global(.messageInput),\n  :global(.editMessageInput),\n  :global(.fileInputLabel),\n  :global(.templateButton),\n  :global(.sendButton),\n  :global(.saveEditButton),\n  :global(.cancelEditButton),\n  :global(.toggleControl) {\n    border-radius: 8px;\n  }\n}\n\n.drawerStack,\n.modalStack {\n  display: grid;\n  gap: 12px;\n}\n\n.drawerStack label {\n  display: grid;\n  gap: 6px;\n  color: var(--muted);\n  font-size: 13px;\n  font-weight: 700;\n}\n\n.drawerStack :global(.ant-select),\n.drawerStack :global(.ant-input) {\n  width: 100%;\n}\n\n.checkboxRow {\n  display: flex !important;\n  grid-template-columns: none !important;\n  align-items: center;\n  gap: 8px !important;\n  color: var(--text) !important;\n}\n\n.checkboxRow input {\n  width: 16px;\n  height: 16px;\n}\n\n.modalControl {\n  width: 100%;\n}\n\n@media (max-width: 1680px) {\n  .kpiStrip {\n    grid-template-columns: repeat(5, minmax(140px, 1fr));\n  }\n\n  .workspace {\n    grid-template-columns: minmax(300px, 360px) minmax(420px, 1fr) minmax(340px, 430px);\n  }\n}\n\n@media (max-width: 1320px) {\n  .workspace {\n    grid-template-columns: minmax(300px, 360px) minmax(0, 1fr);\n  }\n\n  .chatPane {\n    grid-column: 1 / -1;\n    min-height: 520px;\n  }\n\n  .fieldGrid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 980px) {\n  .topBar {\n    grid-template-columns: 1fr;\n  }\n\n  .kpiStrip {\n    grid-template-columns: repeat(2, minmax(140px, 1fr));\n  }\n\n  .workspace {\n    grid-template-columns: 1fr;\n    min-height: auto;\n  }\n\n  .queueList {\n    max-height: 460px;\n  }\n\n  .ticketHeader {\n    grid-template-columns: 1fr;\n  }\n\n  .actionBar {\n    justify-content: flex-start;\n  }\n\n  .slaRow,\n  .fieldGrid {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n@media (max-width: 640px) {\n  .page {\n    padding: 0 8px 12px;\n  }\n\n  .kpiStrip,\n  .slaRow,\n  .fieldGrid {\n    grid-template-columns: 1fr;\n  }\n\n  .queueTop,\n  .queueMeta,\n  .historyItem {\n    grid-template-columns: 1fr;\n    flex-direction: column;\n  }\n\n  .queueMeta {\n    align-items: flex-start;\n  }\n\n  .ticketHeader h1 {\n    font-size: 20px;\n  }\n\n  .ratingPanel {\n    display: grid;\n    align-items: stretch;\n  }\n\n  .ratingButtons {\n    grid-template-columns: repeat(5, minmax(34px, 1fr));\n  }\n\n  .bottomActions :global(.ant-btn),\n  .actionBar :global(.ant-btn) {\n    flex: 1 1 140px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `TicketChatsPage_page__mtJk1`,
	"topBar": `TicketChatsPage_topBar__+bBL3`,
	"searchWrap": `TicketChatsPage_searchWrap__MTzQQ`,
	"sortSelect": `TicketChatsPage_sortSelect__dfbAR`,
	"kpiStrip": `TicketChatsPage_kpiStrip__Dyg+6`,
	"kpiCard": `TicketChatsPage_kpiCard__5Wj-2`,
	"kpiCardActive": `TicketChatsPage_kpiCardActive__gCCuj`,
	"quickFilters": `TicketChatsPage_quickFilters__T9gR3`,
	"quickFilter": `TicketChatsPage_quickFilter__hIqDY`,
	"quickFilterActive": `TicketChatsPage_quickFilterActive__FCux-`,
	"workspace": `TicketChatsPage_workspace__d9glp`,
	"queuePane": `TicketChatsPage_queuePane__dVzaE`,
	"ticketPane": `TicketChatsPage_ticketPane__A+MfL`,
	"chatPane": `TicketChatsPage_chatPane__8zHpy`,
	"paneHeader": `TicketChatsPage_paneHeader__532wK`,
	"queueList": `TicketChatsPage_queueList__oCxST`,
	"queueCard": `TicketChatsPage_queueCard__t0ANc`,
	"queueCardActive": `TicketChatsPage_queueCardActive__RwjFN`,
	"queueCardUrgent": `TicketChatsPage_queueCardUrgent__XfQlN`,
	"queueTop": `TicketChatsPage_queueTop__RVqka`,
	"queueMeta": `TicketChatsPage_queueMeta__YeBDV`,
	"queueTitle": `TicketChatsPage_queueTitle__QObgp`,
	"badgeRow": `TicketChatsPage_badgeRow__IVCBC`,
	"statusPill": `TicketChatsPage_statusPill__lcERd`,
	"smallPill": `TicketChatsPage_smallPill__byCXo`,
	"alertPill": `TicketChatsPage_alertPill__Kk+Xx`,
	"terminalPaymentPill": `TicketChatsPage_terminalPaymentPill__D+yWp`,
	"taskTagPill": `TicketChatsPage_taskTagPill__CRcHs`,
	"waitingStaff": `TicketChatsPage_waitingStaff__X6Jjs`,
	"waitingClient": `TicketChatsPage_waitingClient__mR+I0`,
	"lastMessage": `TicketChatsPage_lastMessage__wH7Cv`,
	"ticketHeader": `TicketChatsPage_ticketHeader__LyIRO`,
	"ticketEyebrow": `TicketChatsPage_ticketEyebrow__20hrB`,
	"ticketTitleInline": `TicketChatsPage_ticketTitleInline__QEh8D`,
	"ticketTags": `TicketChatsPage_ticketTags__6qkua`,
	"actionBar": `TicketChatsPage_actionBar__orzIQ`,
	"bottomActions": `TicketChatsPage_bottomActions__K7LR8`,
	"ticketTagEditor": `TicketChatsPage_ticketTagEditor__+P9US`,
	"slaRow": `TicketChatsPage_slaRow__4ceZa`,
	"slaBadge": `TicketChatsPage_slaBadge__Wkztr`,
	"waitingBox": `TicketChatsPage_waitingBox__NqJv+`,
	"sla_success": `TicketChatsPage_sla_success__85m-+`,
	"sla_warning": `TicketChatsPage_sla_warning__HhJPB`,
	"sla_danger": `TicketChatsPage_sla_danger__tmEEq`,
	"sla_pause": `TicketChatsPage_sla_pause__pxLDN`,
	"sla_done": `TicketChatsPage_sla_done__2GzCn`,
	"ratingPanel": `TicketChatsPage_ratingPanel__xn-kB`,
	"ratingText": `TicketChatsPage_ratingText__ZRD9F`,
	"ratingNote": `TicketChatsPage_ratingNote__wKGyL`,
	"ratingButtons": `TicketChatsPage_ratingButtons__k8hfk`,
	"ratingButton": `TicketChatsPage_ratingButton__38-bz`,
	"ratingButtonActive": `TicketChatsPage_ratingButtonActive__4ytJ0`,
	"fieldGrid": `TicketChatsPage_fieldGrid__erY4s`,
	"field": `TicketChatsPage_field__hkk+k`,
	"fieldValue": `TicketChatsPage_fieldValue__SLTmP`,
	"descriptionBlock": `TicketChatsPage_descriptionBlock__bBeug`,
	"attachmentsBlock": `TicketChatsPage_attachmentsBlock__PpEAJ`,
	"historyBlock": `TicketChatsPage_historyBlock__w+QeH`,
	"sectionTitle": `TicketChatsPage_sectionTitle__jOK0G`,
	"attachmentsList": `TicketChatsPage_attachmentsList__H+NZM`,
	"historyList": `TicketChatsPage_historyList__8MLAY`,
	"historyItem": `TicketChatsPage_historyItem__5J+C+`,
	"drawerStack": `TicketChatsPage_drawerStack__aqcYj`,
	"modalStack": `TicketChatsPage_modalStack__MObg0`,
	"checkboxRow": `TicketChatsPage_checkboxRow__gpYok`,
	"modalControl": `TicketChatsPage_modalControl__wj+kb`
};
export default ___CSS_LOADER_EXPORT___;
